const booking = {
    familyRules: {
        title: 'Family Trip Rules',
        maxTwoAdults: 'Maximum 2 adults (16 years and older) are allowed',
        moreThanTwoAdultsAdvice: 'If you have more than 2 adults, we recommend making separate bookings',
        atLeastOneAdult: 'At least one adult (18 years and older) must be present on the trip'
    },
    // CTA on TripDetailsPage before opening the booking form
    startBooking: 'Start Booking',
    startBookingDescription: 'Select dates, number of participants, and enter details',
    // Steps
    stepQuotes: 'Select Quotes',
    stepParticipants: 'Participant Information',
    stepAddress: 'Contact Information',
    stepReview: 'Review Booking',
    stepPackage: 'Select package',

    // Quotes Selection
    selectQuotes: 'Select the number of quotes',
    selectQuotesDescription: 'Choose how many people will participate in the trip (from 1 to 30)',
    selectPackageTitle: 'Select package',
    selectPackageSubtitle: 'Choose the type of participation based on the number of participants',
    numberOfQuotes: 'Number of quotes',
    pricePerQuote: 'Price per quote',
    pricePerPerson: 'Price per person',
    depositPerPersonLabel: 'Deposit per person',
    totalAmount: 'Total amount',
    depositAmount: 'Deposit',
    balanceAmount: 'Balance',
    insufficientSpotsForPackage: 'Not available: {required} spots needed but only {available} remaining',
    family: 'Family',
    people: 'People',

    // Participants
    participantsInfo: 'Participant Information',
    participantsDescription: 'Enter first and last name of all participants',
    participant: 'Participant',
    firstName: 'First Name',
    lastName: 'Last Name',
    age: 'Age',
    child: 'Child',
    adult: 'Adult',

    // Address
    contactInfo: 'Contact Information',
    contactDescription: 'Enter your address for billing',
    address: 'Address',
    city: 'City',
    postalCode: 'Postal Code',
    country: 'Country',
    phone: 'Phone',

    // Review
    reviewBooking: 'Review Booking',
    reviewDescription: 'Check all details before proceeding to payment',
    tripDetails: 'Trip Details',
    participants: 'Participants',
    paymentSummary: 'Payment Summary',

    // Navigation
    previous: 'Previous',
    next: 'Next',
    cancel: 'Cancel',
    proceedToPayment: 'Proceed to Payment',
    processing: 'Processing...',

    // Validation
    validationError: 'Please complete all required fields',
    createError: 'Error creating booking. Please try again.',
    alreadyBookedError: 'You already have a booking for this trip. You can only book one trip per user.',

    // Date Selection
    selectDate: 'Select Date',
    selectTripDate: 'Select trip date',
    selectDateDescription: 'Choose from available dates for',
    noDatesAvailable: 'No dates available for this trip',
    datesComingSoon: 'Dates for this trip will be announced soon!',
    followSocialForUpdates: 'Follow us on social media for updates',
    spotsAvailable: 'spots available',
    spotsTotal: 'out of',
    spotsTotalLabel: 'total',
    fullyBooked: 'Full',
    spotsRemaining: 'spots remaining',

    // Address info
    addressSavedInfo: 'Your saved address data will be used. You can modify them below.',
    addressWillBeSaved: 'This address data will be saved to your account for future bookings.',

    // Footer note
    childrenDefinition: '* by child we mean under 16 years old.',

    // Country options
    countryOther: 'Other',

    // Discount Code
    discountCode: {
        title: 'Discount Code',
        enterCode: 'Enter discount code',
        placeholder: 'Enter discount code',
        apply: 'Apply',
        validating: 'Validating...',
        applied: 'Code applied',
        appliedMessage: 'Discount code applied! {percent}% discount',
        invalid: 'Invalid discount code',
        validationError: 'Error validating discount code',
        removed: 'Discount code removed',
        selectDateFirst: 'Please select a trip date first',
        enterCodeError: 'Please enter a discount code',
    },

    // Trip Types
    tripTypes: {
        solo: 'Solo Trip',
        duo: 'Duo Trip',
        trio: 'Family - 3 People',
        pocker: 'Family - 4 People',
    },

    // Trip Descriptions
    tripDescriptions: {
        solo: 'Single trip',
        duo: 'Couple trip',
        trio: 'Family trip (2 adults + 1 child*)',
        pocker: 'Family trip (2 adults + 2 children*)',
    },

    // Review Step Labels
    selectedDate: 'Selected date',
    dateLabel: 'Date',
    participantNumber: 'Participant',
    nameLabel: 'Name',
    lastNameLabel: 'Last Name',
    ageLabel: 'Age',
    yearsOld: 'years old',
    addressLabel: 'Address',
    cityLabel: 'City',
    postalCodeLabel: 'Postal Code',
    countryLabel: 'Country',
    phoneLabel: 'Phone',
    originalPrice: 'Original price',
    discount: 'Discount',
    remove: 'Remove',

    // Errors
    error: {
        loadingDates: 'Error loading available dates',
        noDatesAvailable: 'No dates available for this trip',
        loadingTripConfig: 'Error loading trip configuration',
        selectDateForTrip: 'Please select a date for the trip',
        noPriceAvailable: 'No price available for this trip',
    },

    // Validation Messages
    validation: {
        atLeastOneAdult18: 'At least one participant must be 18 years or older',
        familyTripNeedsChild: 'For family trips (3-4 people) at least one child under 16 years is required',
        familyTripMaxAdults: 'For family trips (3-4 people) a maximum of 2 adults (16+ years) are allowed. You entered {count} adults.',
        fillAllParticipantFields: 'Please fill in all required fields for participants',
        fillAllAddressFields: 'Please fill in all required address fields',
        selectDateToContinue: 'Select a date to continue',
        selectParticipationType: 'Select a participation type to continue',
    },
};

export default booking;
